export const getBase64 = (file) => {
  let reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    const base64data = reader.result
    const strBase64 = base64data.substr(base64data.indexOf(',') + 1)
    allBase64(strBase64)
  }

  reader.onerror = function (error) {
    console.log('Error: ', error)
  }
}

const allBase64 = (base64) => {
  arrayBase64.push(base64)
}

export const clearArrayBase64 = () => (arrayBase64 = [])
export let arrayBase64 = []

export const formatPrice = (value) => {
  return new Intl.NumberFormat('th-TH').format(value)
}

export const formatMoneyAmount = (value) => {
  return new Intl.NumberFormat('th-TH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export const formatDateForSendGift = (nanosecond, seconds) => {
  if (nanosecond !== undefined || seconds !== undefined) {
    const timestampInMilliseconds = seconds * 1000 + Math.floor(nanosecond / 1000000)
    const dateObj = new Date(timestampInMilliseconds)
    return dateObj.toLocaleString('th-TH')
  }
  return '-'
}

export const validateTextOnly = (input) => {
  return input === '' || input.match(/^[\u0E00-\u0E7Fa-zA-Z']+$/)
}

export const validateNumberOnly = (input) => {
  return input === '' || input === '0' || input.match(/^[0-9]+$/)
}
